import React from 'react'
import { SessionStatusEnum } from '../../common/enums/session-status.enum'
import { PusherProvider } from '@harelpls/use-pusher'
import { authFetch } from '../../common/networking/auth-fetch'
import { useSession } from 'next-auth/react'

type Props = {
  children: React.ReactNode
}

export default function CustomizedPusherProvider({ children }: Props) {
  const { data: session, status } = useSession()

  // @ts-ignore
  if (session?.accessToken && status === SessionStatusEnum.AUTHENTICATED) {
    return (
      // @ts-ignore
      <PusherProvider
        clientKey={process.env.NEXT_PUBLIC_DEFAULT_PUSHER_KEY!}
        cluster={process.env.NEXT_PUBLIC_DEFAULT_PUSHER_HOST!}
        authorizer={({ name }) => ({
          authorize: async (socketId, callback) => {
            try {
              //@ts-ignore
              const res = await authFetch(session?.accessToken).post(
                `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/websocket/auth`,
                {
                  socket_id: socketId,
                  channel_name: name,
                },
              )
              const response = await res.json()
              const auth = response.auth
              callback(null, { auth, channel_data: response.channel_data })
            } catch (error) {
              if (error instanceof Error) {
                callback(error, { auth: '' })
              } else {
                callback(new Error(), { auth: '' })
              }
            }
          },
        })}
      >
        {children}
      </PusherProvider>
    )
  }

  return null
}
